<script setup>

import Card from "@/Components/Card.vue";
import Badge from "@/Components/Badge.vue";
import Loading from "@/Components/Loading.vue";
import {getPropertyName} from "@/helper.js";
import {Link} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import {storeToRefs} from "pinia";
import {useUser} from "@/Store/User.js";
import OfferRaiting from "@/Components/OfferRaiting.vue";


const props = defineProps({
    data: Object,
    loading: {
        type: Boolean,
        default: false
    }
})

const {getUserStatusByIdOrStatus} = storeToRefs(useUser())

</script>

<template>
    <Card class="flex flex-col gap-[0.38rem] relative overflow-hidden">
        <Link :href="route('offers.show', data.id)" class="flex px-2.5 pt-[0.38rem] dark:hover:bg-gray-900 hover:bg-slate-100 flex-col gap-[0.38rem] relative overflow-hidden">
            <div class="flex justify-between cursor-pointer">
                <div class="dark:text-slate-200 text-sm tracking-wider font-normal leading-120 mr-4">{{
                        data.title
                    }}
                </div>
                <div class="flex items-center gap-1">
                <span class="text-base dark:text-slate-200 tracking-wider font-medium leading-full w-max">{{
                        data.price_currency_formatted
                    }}</span>
                </div>
            </div>

            <div class="flex gap-x-1 gap-y-[0.1875rem] flex-wrap cursor-pointer">
                <template v-for="properties in data.offer_properties">
                    <Badge :content-classes="['h-4', 'cursor-pointer']" type="info2xl"
                           :value="getPropertyName(properties)">
                    </Badge>
                </template>
            </div>
        </Link>
        <div class="flex gap-2.5 px-2.5 pb-[0.38rem] items-center w-fit group">
            <Link :href="route('users.show.reviews', data.user)"
                  class="flex items-center w-[2.125rem] h-[2.125rem] rounded-full border border-gray-300">
                <img class="rounded-full" style="width: 34px; height: 34px" :src="data.user.profile_photo_url" :alt="data.user.name">
            </Link>
            <div class="max-w-[17.25rem] w-fit border-t border-dashed border-slate-600 font-condensed">
                <Link :href="route('users.show.reviews', data.user)" class="w-fit block">
                    <div class="px-1 py-0.5 leading-full flex gap-2">
                        <p class="tracking-wide dark:text-slate-200 group-hover:underline text-sm font-normal leading-full line-clamp-1 break-all">
                            {{
                                data.user.name
                            }}</p>
                        <Badge
                            :type="getUserStatusByIdOrStatus(data.user.id, data.user.is_online) ? 'success' : 'danger'"
                            :value="getUserStatusByIdOrStatus(data.user.id, data.user.is_online) ? 'Online' : 'Offline'"></Badge>
                    </div>
                    <div class="px-1 text-xs leading-full font-light text-slate-500 dark:text-slate-400 w-fit">
                        <span v-if="data.user.reviews_count === 0" class="dark:text-slate-200 font-light leading-full">
                            {{
                                $t('no reviews')
                            }}</span>
                        <span v-else class="flex font-light dark:text-slate-200 leading-full">
                            <OfferRaiting :rating="data.user.rating"/>
                            {{ $t('reviews') }}: {{
                                data.user.reviews_count
                            }}</span>
                    </div>
                    <div class="px-1 py-0.5 text-xs font-bold leading-full text-slate-500 dark:text-slate-400 w-fit">
                        {{ data.user.on_site_desc }}
                    </div>
                </Link>

            </div>
        </div>
        <loading class="px-2.5 pb-[0.38rem]" v-if="loading"/>
    </Card>
</template>

<style scoped>

</style>
